module.exports = __webpack_public_path__ + "static/img/network_widgrt_2.d42f92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/network_widgrt_2.png
// module id = 08xq
// module chunks = 11